import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://jlahqomusbhyhwdawlfj.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImpsYWhxb211c2JoeWh3ZGF3bGZqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTEzNTkyMjAsImV4cCI6MjA2NjkzNTIyMH0.w5-61383gGtsLw392KaGkDAQuCsacFp2lYQFSQYdADA'

if (SUPABASE_URL === 'https://<PROJECT-ID>.supabase.co' || SUPABASE_ANON_KEY === '<ANON_KEY>') {
  throw new Error('Missing Supabase variables')
}

const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})

console.log('Supabase: Connected to', SUPABASE_URL)

export default supabase